export function getDateOfISOWeek(week, year) {
  let baseDate = new Date(year, 0, 1 + (week - 1) * 7);
  if (baseDate.getDay() <= 4) {
    baseDate.setDate(baseDate.getDate() - baseDate.getDay() + 1);
  } else {
    baseDate.setDate(baseDate.getDate() + 8 - baseDate.getDay());
  }
  return baseDate;
}

export function toISOString(date) {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${year}-${("0" + month).slice(-2)}-${("0" + day).slice(-2)}`;
}
